<template>
  <footer class="page-footer">
    <div class="footer-content">
      <template v-if="$store.state.userinfo.isAdmin">
        <div class="online-count">
          <span class="online-dot"></span>
          <span>在线人数: {{ $store.state.onlineCount }}人</span>
        </div>
        <span class="divider">|</span>
        <div class="daily-visitor-count">
          <span class="visitor-icon">👥</span>
          <span>24小时访问: {{ $store.state.dailyVisitorCount }}人</span>
        </div>
        <span class="divider">|</span>
      </template>
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="beian-link">
        {{ beianNumber }}
      </a>
      <span class="divider">|</span>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank" rel="noopener noreferrer"
         class="gongan-link">
        <img src="https://img.lkval.com/static/assets/gonganbeian.png" alt="公安备案" class="gongan-icon"/>
        <span>{{ gonganBeianNumber }}</span>
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'PageFooter',
  data() {
    return {
      beianNumber: '晋ICP备2026000928号-1',
      gonganBeianNumber: '晋公网安备14050002001939号'
    }
  }
}
</script>

<style scoped>
.page-footer {
  background-color: #f8f9fa;
  color: #666;
  padding: 0 0;
  text-align: center;
  border-top: 1px solid #eee;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.footer-content {
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.divider {
  color: #ccc;
}

.online-count {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #666;
  font-size: 14px;
}

.online-dot {
  width: 8px;
  height: 8px;
  background-color: #67c23a;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.daily-visitor-count {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #666;
  font-size: 14px;
}

.visitor-icon {
  font-size: 12px;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.footer-content a {
  color: #666;
  text-decoration: none;
}

.footer-content a:hover {
  color: #333;
  text-decoration: underline;
}

.beian-link,
.gongan-link {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #666;
  text-decoration: none;
}

.beian-link:hover,
.gongan-link:hover {
  color: #333;
  text-decoration: underline;
}

.gongan-icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  display: block;
}

/* 仅在屏幕宽度小于等于 768px 时隐藏 */
@media screen and (max-width: 768px) {
  .page-footer {
    display: none;
  }
}
</style>
